import React, { useState, useEffect, useCallback } from 'react';
import Logo from './Logo';
import { APIfetch } from '../../APIRoot';
import { HeaderWrapper } from './HeaderWrapper';
import { UpperMenu } from './UpperMenu';
import { BottomMenu } from './BottomMenu';
import { useKeycloakContext } from '../../contexts/AuthContext';

const fetchHospitalInformation = async partnerId =>
  await APIfetch(`hospitals/${partnerId}`);

export default function Header(props) {
  const [name, setName] = useState('');
  const [siteName, setSiteName] = useState('');
  const { initialized, ...keycloak } = useKeycloakContext();

    const loadData = useCallback( async (partnerId, resetState = true) => {
      if (partnerId) {
        const { name, siteName } = await fetchHospitalInformation(partnerId);
        setName(name);
        setSiteName(siteName);
      } else if (resetState) {
        setName('');
        setSiteName('');
      }
    }, []);

  useEffect(() => {
    props.onRef(this);
    return () => {
      props.onRef(undefined);
    };
  }, [props]);

  useEffect(() => {
    if (initialized && keycloak.authenticated) {
      loadData(keycloak.tokenParsed.provider_id, false);
    }
    return () => {
      loadData(null, true);
    };
  }, [initialized, keycloak.authenticated, keycloak.tokenParsed.provider_id, loadData ]);

  return (
    <HeaderWrapper>
      <Logo />
      <div>
        <UpperMenu />
        <BottomMenu placeName={name} siteName={siteName} />
      </div>
    </HeaderWrapper>
  );
}